var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_32516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 2H18.5V1C18.5 0.45 18.05 0 17.5 0C16.95 0 16.5 0.45 16.5 1V2H7.5V1C7.5 0.45 7.05 0 6.5 0C5.95 0 5.5 0.45 5.5 1V2H3C1.35 2 0 3.35 0 5V21C0 22.65 1.35 24 3 24H21C22.65 24 24 22.65 24 21V5C24 3.34 22.65 2 21 2ZM9.33 16.5V13H14.66V16.5H9.33ZM14.67 18.5V22H9.34V18.5H14.67ZM22 11H16.67V7.5H22V11ZM14.67 7.5V11H9.34V7.5H14.67ZM7.33 7.5V11H2V7.5H7.33ZM2 13H7.33V16.5H2V13ZM16.67 13H22V16.5H16.67V13ZM2 21V18.5H7.33V22H3C2.45 22 2 21.55 2 21ZM21 22H16.67V18.5H22V21C22 21.55 21.55 22 21 22Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_32516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.28aa5c52.svg";
export { ForwardRef as ReactComponent };